








import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game, TakeOtherAction } from '@/class/game'
import { GamePlayerData } from '@/class/gamePlayer'

@Component
export default class TakeOtherResultMessages extends Vue {
  @Prop() game!: Game
  @Prop() takeOtherAction!: TakeOtherAction

  get messages () {
    const messages: string[] = []

    Object.values(this.takeOtherAction.players)
    .filter(p => p.takeOther)
    .forEach(p => {
      const playerName = this.getName(p)

      if (p.selectedPlayerId) {
        const targetName = this.getName(this.takeOtherAction.players[p.selectedPlayerId])
        messages.push(`${playerName}は${targetName}を道連れにした`)
      } else {
        messages.push(`${playerName}は誰も道連れにしなかった`)
      }
    })

    return messages
  }

  getName(player: GamePlayerData) {
    return `${player.name}`
  }
}
